"production" === process.env.NODE_ENV ? module.exports = require("./client") : module.exports = require("./server");